// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__THOB2","content":"styles_content__27IYB","tableWrap":"styles_tableWrap__2I5jd"};